import { Box, Container } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomButton from '../../../Components/CustomButton/CustomButton'

import { makeGetRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import BucketListFormDialog from './BucketListFormDialog'
import ListDocuments from './ListDocuments'

export const MaBucketList = () => {
  const [documents, setDocuments] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const formRef = useRef()
  const [loading, setLoading] = useState(false)

  const location = useLocation()

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      Nom: '',
      Description: '',
      Categorie: '',
      Prix: '',
      Devise: '',
      Temps: '',
      DateObjectif: '',
      Duree: '',
      Statut: '',
      Datedecreation: '',
    },
  })

  useEffect(() => {
    fetchDocuments()
  }, [location.search])

  const handleUpdateList = (document, activeDocument) => {
    let tmpObject = JSON.parse(JSON.stringify(documents))
    if (activeDocument.Categorie) {
      const activeObjIndex = tmpObject.results.findIndex((v) => v.id === activeDocument.id)
      tmpObject.results[activeObjIndex] = document
      setDocuments({ ...tmpObject })
    } else {
      tmpObject.results.push({ ...document })
      setDocuments({ ...tmpObject, count: tmpObject.count + 1 })
    }
  }
  const fetchDocuments = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudBucketList}?${location.search.slice(1)}`
    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setDocuments({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  return (
    <div>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            {/* <UploadOperations /> */}
            {/* <CreateOperationForm setOperations={setOperations} /> */}
            <CustomButton onClick={() => formRef.current.handleClickOpen()}>Créer</CustomButton>
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  formRef.current.handleClickOpen(true)
                } else {
                  alert('Please Select one document for modifier')
                }
              }}
            >
              Modifier
            </CustomButton>
            <CustomButton>Supprimer</CustomButton>
          </Box>
        </Box>
        <ListDocuments
          fetchDocuments={fetchDocuments}
          setSelectedRows={setSelectedRows}
          documents={documents}
        />
        <BucketListFormDialog
          ref={formRef}
          documents={documents}
          handleUpdateList={handleUpdateList}
          selectedRows={selectedRows}
        />
      </Container>
    </div>
  )
}
